module.exports = __webpack_public_path__ + "img/icon-tw.1347c9a1.png";